import { render, staticRenderFns } from "./refund_detail.vue?vue&type=template&id=1f1615e6&scoped=true"
import script from "./refund_detail.vue?vue&type=script&lang=js"
export * from "./refund_detail.vue?vue&type=script&lang=js"
import style0 from "./refund_detail.vue?vue&type=style&index=0&id=1f1615e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1615e6",
  null
  
)

export default component.exports